import { Meter } from "../types/Meter";

export const EMPTY_METER_VALUES: Meter = {
  location: "",
  serialNumber: "",
};
